import { DependencyList, useEffect } from 'react';

export function useStepControlsSync<T>(
  controls: T,
  onStepControlsChange: ((controls: T) => void) | undefined,
  deps: DependencyList
): void {
  useEffect(() => {
    onStepControlsChange?.(controls);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, onStepControlsChange]);
}
